// src/hooks/results/usePulseScanResults.js
import { useMeasurementResults } from "./useMeasurementResults";

export function usePulseScanResults(
  db,
  uid,
  { pageSize = 50, subjectId = null } = {},
) {
  return useMeasurementResults(db, uid, {
    collectionName: "RecordingTidalBreathing",
    context: "pulse",
    pageSize,
    subjectId,
  });
}
